import type { JSX } from 'preact'

interface Props {
  value: string | undefined | null
  max: number
  className?: string
  warnAt?: number // fraction 0..1 at which to warn (default 0.8)
}

export function CharCounter({ value, max, className = '', warnAt = 0.8 }: Props): JSX.Element {
  const len = (value ?? '').length
  const ratio = max > 0 ? len / max : 0
  const tone = len >= max
    ? 'text-red-600 dark:text-red-400'
    : ratio >= warnAt
      ? 'text-amber-600 dark:text-amber-400'
      : 'text-slate-400 dark:text-slate-500'

  return (
    <div aria-live="polite" className={`mt-1 text-xs text-right ${tone} ${className}`}>
      {len}/{max}
    </div>
  )
}
